module.exports = __webpack_public_path__ + "static/img/成都分部背景@2x.ab580f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/成都分部背景@2x.png
// module id = h4uV
// module chunks = 0